import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { validity_date_v2 } from 'src/app/core/Constants/static';
import { DiagnosisList } from 'src/app/core/Models/interfaces/master-management/diagnosisList';
import { Pagination } from 'src/app/core/Models/interfaces/pagination';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { DiagnosisCodeService } from '../../../services/diagnosis-code.service';
import { permission } from 'src/app/core/Constants/permissions';

@Component({
  selector: 'app-diagnosis-code-management-list',
  templateUrl: './diagnosis-code-management-list.component.html',
  styleUrls: ['./diagnosis-code-management-list.component.css']
})
export class DiagnosisCodeManagementListComponent implements OnInit {

  @ViewChildren('focusedElement') focusedElement!: QueryList<ElementRef>;

  private sortParams!: string;
  private page_limit!: number;

  public permission=permission;
  public diagnosisfilterForm!: FormGroup;
  public page_no: number = 1;
  public totalCount!: number;
  public isAddpage: boolean = false;
  public isEdit: boolean = false;
  public feild_startDate = validity_date_v2;
  public columnSort: Record<string, { sortType: string, clicked: boolean }> = {
    activeFrom: {
      sortType: 'ascending',
      clicked: true
    },
    diaganosisVersion: {
      sortType: 'ascending',
      clicked: true
    },
    diaganosisVersionDesc: {
      sortType: 'ascending',
      clicked: true
    },
  };
  public selectedVersion!: DiagnosisList;
  public diagnosisList: DiagnosisList[] = []

  constructor(
    private toasterandLoader: ToasterService,
    private userService: UserService,
    private router: Router,
    private DiagnosisCodeService:DiagnosisCodeService
  ) { }


  private createfilterForm(): void {
    this.diagnosisfilterForm = new FormGroup({
      version: new FormControl(null),
      validity: new FormControl(null),
      inUse: new FormControl(null)
    });
  }


  private applyFilter(): void {
    // if (this.checkPermission('getDrugList')) {
    this.toasterandLoader.isLoaderEnable(true);
    const validity = this.diagnosisfilterForm?.value?.validity;
    const valStart = validity?.substring(0, validity.indexOf(' '));
    const parts: string[] = validity?.split(' ');
    const valEnd = parts?.pop();
    const validityStart = valStart?.split("/").reverse().join("-");
    const validityEndDate = valEnd?.split("/").reverse().join("-");
    const payLoad = {
      per_page: this.page_limit,
      page: this.page_no,
      sort: this.sortParams,
      diaganosisVersion: this.diagnosisfilterForm?.value?.version ? this.diagnosisfilterForm?.value?.version : '',
      activeFrom: validityStart ? validityStart : '',
      expiredOn: validityEndDate ? validityEndDate : '',
      isActive: this.diagnosisfilterForm?.controls?.['inUse']?.value ? 1 : '',
    }
    this.DiagnosisCodeService.getDiagnosisList(payLoad).subscribe({
      next: (response) => {
        if (response) {
          this.diagnosisList = response?.data?.data;
          this.totalCount = response?.data?.total;
          // if (!this.diagnosisList?.length) this.showNavigation = true;
          this.toasterandLoader.isLoaderEnable(false);
        }
      },
      error: (error) => {
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: error.message
        });
        this.toasterandLoader.isLoaderEnable(false);
      },
    })
    // }
  }

  private isScrollIntoViewNeeded(): void {
    setTimeout(() => {
      this.focusedElement.last?.nativeElement.scrollIntoView();
    }, 100);
  }

  private navigateToView(item: DiagnosisList): void {
    let url = this.router.url;
    if (url.includes('/master-management/diagnosis-management')) {
      this.router.navigate(['master-management', 'diagnosis-detail-view', item.diaganosisVersionId]);
    }
  }





  public ngOnInit():void {
    this.createfilterForm();
  }

  public checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }


  public sortColumn(colName: string): void {
    for (const key in this.columnSort) {
      if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
        const element = this.columnSort[key];
        if (key == colName) {
          this.columnSort[colName].clicked = true;
          this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
          this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
          this.applyFilter();
        } else {
          this.columnSort[key].sortType = 'ascending';
        }
      }
    }
  }


  public addNewDiagnosis(): void {
    this.isAddpage = true;
    this.isEdit = false;
  }

  public currentPageDetail(event: Pagination): void {
    if (event) {
      this.page_no = event.button_no;
      this.page_limit = event.item_per_page;
    }
    this.isScrollIntoViewNeeded();
    this.applyFilter();
  }

  public closeAddEdit(event: boolean) {
    this.isAddpage = false;
    this.filterOnClick(); 
  }

  public filterOnClick(): void {
    this.page_no = 1;
    this.applyFilter();
  }
  public resetFilter(): void {
    this.diagnosisfilterForm.reset();
    this.page_limit = 10;
    this.page_no = 1;
    this.totalCount = 1;
    // this.showNavigation = false;
    this.applyFilter();
  }

  public ShowDetailView(version: DiagnosisList): void {
    this.navigateToView(version)
  }

  public showEdit(item: DiagnosisList): void {
    this.isAddpage = true;
    this.isEdit = true;
    this.selectedVersion = item;
  }


}
